import type { PaymentNotification } from "models/Notification";
import type { NotificationSettings } from "models/NotificationSettings";
import type { Client } from "modules/applications";
import type { Account } from "modules/bank-accounts";
import type { Bank } from "modules/banks";
import type { CashManagementAccount } from "modules/cash-management";
import type { Customer, GetCustomerResponse } from "modules/customers";
import type { Payment } from "modules/transactions";
import type { User } from "modules/user-management";

export const SUBJECT_ACCOUNT = "Account";
export const SUBJECT_BANK = "Bank";
export const SUBJECT_CLIENT = "Client";
export const SUBJECT_CLIENT_VERIFY_NOTIFICATIONS =
  "client-verify-notifications";
export const SUBJECT_DYNAMIC_BENEFICIARY = "DynamicBeneficiary";
export const SUBJECT_PAYMENT_NOTIFICATION = "PaymentNotification";
export const SUBJECT_USER = "User";
export const SUBJECT_NOTIFICATION_SETTINGS = "NotificationSettings";
export const SUBJECT_CUSTOMER = "Customer";
export const SUBJECT_PAYMENT = "Payment";
export const SUBJECT_REFUND = "Refund";
export const SUBJECT_PAYMENT_EXTERNAL_LINKS = "payment-external-links";
export const SUBJECT_CUSTOMER_PRODUCT_FLAGS = "CustomerProductFlags";
export const SUBJECT_CIRCUIT_BREAKER = "circuit-breaker";
export const SUBJECT_USER_PRODUCT_INTEREST = "user-product-interest";
export const SUBJECT_VERIFICATION = "verification";
export const SUBJECT_VERIFY = "verify";
export const SUBJECT_PAY_BY_LINK = "PayByLink";
export const SUBJECT_PAYOUTS = "Payouts";

export const SUBJECT_CUSTOMER_COUNTRIES = "customer-banks";
export const SUBJECT_CUSTOMER_PAYMENTS_PROVIDERS =
  "customer-payments-providers";
export const SUBJECT_CASH_MANAGEMENT = "cash-management";
export const SUBJECT_CASH_MANAGEMENT_ACCOUNT = "cash-management-account";
export const SUBJECT_CASH_MANAGEMENT_SETTLEMENT_NOTIFICATION =
  "cash-management-settlement-notification";
export const SUBJECT_CASH_MANAGEMENT_PROVIDER_SETUP =
  "cash-management-provider-setup";

export type Subject =
  | Account
  | typeof SUBJECT_ACCOUNT
  | Bank
  | typeof SUBJECT_BANK
  | Client
  | typeof SUBJECT_CLIENT
  | Customer
  | GetCustomerResponse
  | typeof SUBJECT_CUSTOMER
  | typeof SUBJECT_DYNAMIC_BENEFICIARY
  | Payment
  | typeof SUBJECT_PAYMENT
  | PaymentNotification
  | typeof SUBJECT_PAYMENT_NOTIFICATION
  | User
  | typeof SUBJECT_USER
  | NotificationSettings
  | typeof SUBJECT_REFUND
  | typeof SUBJECT_PAYMENT_EXTERNAL_LINKS
  | typeof SUBJECT_NOTIFICATION_SETTINGS
  | typeof SUBJECT_USER_PRODUCT_INTEREST
  | typeof SUBJECT_CIRCUIT_BREAKER
  | typeof SUBJECT_CUSTOMER_PRODUCT_FLAGS
  | typeof SUBJECT_CUSTOMER_COUNTRIES
  | typeof SUBJECT_CUSTOMER_PAYMENTS_PROVIDERS
  | typeof SUBJECT_CASH_MANAGEMENT
  | CashManagementAccount
  | typeof SUBJECT_CASH_MANAGEMENT_ACCOUNT
  | typeof SUBJECT_CASH_MANAGEMENT_SETTLEMENT_NOTIFICATION
  | typeof SUBJECT_CASH_MANAGEMENT_PROVIDER_SETUP
  | typeof SUBJECT_VERIFY
  | typeof SUBJECT_VERIFICATION
  | typeof SUBJECT_CLIENT_VERIFY_NOTIFICATIONS
  | typeof SUBJECT_PAY_BY_LINK
  | typeof SUBJECT_PAYOUTS;

export const PROPERTY_ID = "id";
